import React, { useState } from 'react'
import BaseHome from '../Home/BaseHome'
import Transactions from './Transactions'
import { useNavigate } from 'react-router-dom';
import TabWithBottomBorder from '../Common/TabWithBottomBorderNewStyle';

const MyRecentTransaction = () => {
  const navigate = useNavigate();
  const tabs = ["coins", "gems"]
  //"invoice" - removed 
  const [activeTab, setActiveTab] = useState(0)

  const getTabContent = () => {
    switch (activeTab) {
      case 0:
        return (
          <div className="mytab-content">
            <Transactions key="coin" type={"coin"} />
          </div>
        );
      case 1:
        return (
          <div className="mytab-content">
            <Transactions key="gems" type={"gems"} />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <BaseHome isRemoveScroll={true} title={"recent transaction"} onBackClick={() => navigate(-1)}>
       <div className="commontabs testimonial-tabs autosize-tab">
        <div className="commontabs-innerwrap tab-backgrounnd-new-style">
        <TabWithBottomBorder getTabContent={getTabContent}  tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />
          {/* <Tabs
            value={value}
            onChange={handleChange}
            className="tabs-container"
          >
            {pointCategoryList?.map((category, index) => {
              return <Tab
                label={category?.name}
                className="tab tabs-font-size"
                style={{ textTransform: "lowercase" }}
              />;
            })}
          </Tabs> */}
        </div>
      </div>
      <div className="mytab-content-container mytab-content-container-new">{getTabContent()}</div>
      {/* <TabWithBottomBorder getTabContent={getTabContent} tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} /> */}
    </BaseHome>
  )
}

export default MyRecentTransaction